import compose from 'redux/lib/compose';
import { prepareComponent, withInitAction } from '@mediamonks/react-redux-component-init';
import PublicNavigationLinks from '../../molecules/PublicNavigationLinks';

import RegistrationTemplate from './RegistrationTemplate';

const addInitAction = withInitAction({
  prepared: ({}, dispatch) => dispatch(prepareComponent(PublicNavigationLinks)),
});

export default compose(addInitAction)(RegistrationTemplate);
